import googleApi from 'vendor/google-maps-api';
import _actions from './actions';
import urlUtils from 'lib/url-utils';

const _stores = {};
let _global = window;

class Framework {

	static set global(obj){
		_global = obj || window;
	}

	static get global(){
		return _global;
	}

	static getStore(storeName) {
		return _stores[storeName];
	}

	static registerStore(storeName, store) {
		let errorMessage = 'registerStore parameters are (storeName: string, store: function(callback, bindContext))';
		if(arguments.length !== 2) {
			throw new Error(errorMessage);
		}

		if(store.listen == null || typeof store.listen !== 'function') {
			throw new Error(errorMessage);
		}

		if(storeName == null || storeName === '') {
			throw new Error(errorMessage);
		}

		if(_stores[storeName] == null) {
			_stores[storeName] = store;
		}
	}

	static get actions() {
		return _actions;
	}

	static openPartnerLink(href, paramName, newWindow, forceSso, obj) {
		var sso = Framework.getStore('ProfileStore').getInitialData().sso;
		if(sso){
			var params = {};
			params[paramName] = sso;

			Framework.navigateTo(href, params, newWindow);
		} else if(forceSso === 'true') {
			if(obj !== null && typeof obj !== 'undefined') {
				href = Framework.getStore('UrlStore').getInitialData().globalPageDrivers.login + '?resource=' + encodeURIComponent(obj.href);
			} else{
				href = Framework.getStore('UrlStore').getInitialData().globalPageDrivers.loginResource;
			}
			Framework.navigateTo(href, null, newWindow);
		} else{
			Framework.navigateTo(href, null, newWindow);
		}
	}

	static navigateTo(href, params, newWindow, prefix) {
		var url = urlUtils.appendQueryParam(params, href);

		if(newWindow) {
			_global.open(url, '_blank');
		} else{
			_global.location.href = url;
		}
	}

	static mountTo(obj) {
		obj.LtFramework = Framework;
	}

	static initializeGoogleApi() {
		return googleApi.initialize();
	}
}

export default Framework;
